export default __webpack_public_path__ + "54090b278a57517daa38f71492cb488b.png";